import { useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";

const Toaster = (props) => {
  const {
    show,
    title,
    toastType,
    position,
    autoClose,
    hideProgressBar,
    closeOnClick,
    pauseOnHover,
    draggable,
    progress,
    theme,
    rtl,
    closeButton,
  } = props;

  const toastShownRef = useRef(false);

  useEffect(() => {
    if (show && !toastShownRef.current) {
      const toastOptions = {
        position: position || "top-right",
        autoClose: autoClose || 2000,
        hideProgressBar: hideProgressBar !== undefined ? hideProgressBar : false,
        closeOnClick: closeOnClick !== undefined ? closeOnClick : true,
        pauseOnHover: pauseOnHover !== undefined ? pauseOnHover : true,
        draggable: draggable !== undefined ? draggable : true,
        progress: progress,
        theme: theme || "dark",
        rtl: rtl || false,
        onClose: () => {
          closeButton();
        },
      };

      if (toastType === "success") {
        toast.success(title, toastOptions);
      } else if (toastType === "failure") {
        toast.error(title, toastOptions);
      } else if (toastType === "info") {
        toast.info(title, toastOptions);
      } else if (toastType === "warning") {
        toast.warn(title, toastOptions);
      } else {
        toast(title, toastOptions);
      }
      toastShownRef.current = true;
    } else if (!show) {
      toastShownRef.current = false;
    }
  }, [
    show,
    title,
    toastType,
    position,
    autoClose,
    hideProgressBar,
    closeOnClick,
    pauseOnHover,
    draggable,
    progress,
    theme,
    rtl,
    closeButton,
  ]);

  return (
    <ToastContainer
      position="top-right"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick={true}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="dark"
    />
  );
};

export default Toaster;

/**
 * To call the toaster
 * const [show, isSHow] = useState(false);
 * const closeButton = () => {
   isShowToaster(false);
  };
 * <Toaster
        show={show}
        toastType={"success"} // Pass the desired type
        title={"wow so easy"} '' Title to show
        theme={"light"}
        position="top-center"
        closeButton={()=>{}}
      />
 * 
 * 
*/
